package no.vareflow.app.domain

import kotlin.js.Date

actual fun randomId(): String = js("crypto.randomUUID()")

actual fun nowMillis(): Long = Date.now().toLong()
